<template>
  <div class="middle-bottom">
    <div class="mhead">
      <div class="item">
        总课时：<span>{{ list.total.total_count }}</span>
      </div>
      <div class="item">
        总人次：<span>{{ list.total.total_nums }}</span>
      </div>
    </div>
    <div class="table">
      <div class="thead">
        <div class="i-item name">名称</div>
        <div class="i-item percent">服务类型</div>
        <div class="i-item kcal">服务人次</div>
      </div>
      <div class="tbody high">
        <transition-group name="list" tag="div">
          <div class="item" v-for="(item, i) in p_list" :key="i">
            <div class="i-item name">
              {{ item.title }}
            </div>
            <div class="i-item percent">{{ item.category_name }}</div>
            <div class="i-item kcal">{{ item.nums }}</div>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
let mtimer = null
let ltimer = null

export default {
  filters: {
    num(val) {
      if (val < 10) {
        val = 'No.00' + val
      } else if (val < 100) {
        val = 'No.0' + val
      } else {
        val = 'No.' + val
      }
      return val
    },
  },
  props: {
    count: {
      default: 10,
    },
    list: {
      default() {
        return {
          list: [],
        }
      },
    },
  },
  data() {
    return {
      page_size: 5,

      active: 1,

      p_step: 0,
      c_step: 0,

      p_list: [],
      pList: [],
      c_list: [],
      cList: [],
    }
  },
  mounted() {
    this.page_size = 4

    this.p_step = 0
    this.pList = this.list.list

    this.pList.forEach(row => {
      if (row.category_name == '健康服务') {
        row.category_name = '培训指导'
      }
    })

    this.$set(this, 'p_list', this.list.list.slice(0, this.page_size))
    ltimer = setInterval(() => {
      this.p_list = []

      setTimeout(() => {
        let p_step = this.p_step + 1

        // console.log(p_step, Math.floor(this.pList.length / this.page_size))

        if (p_step > Math.ceil(this.pList.length / this.page_size) - 1) {
          p_step = 0
        }

        this.p_list = this.pList.slice(this.page_size * p_step, this.page_size * p_step + this.page_size)

        this.p_step = p_step
      }, 600)
    }, this.page_size * 2000)
  },
  beforeDestroy() {
    clearInterval(mtimer)
  },
  methods: {
    on_change(i) {
      this.active = i
    },
  },
}
</script>

<style scoped>
.list-enter-active {
  transition: all 1s;
  transform-origin: top;
}

.list-leave-active {
  transition: all 0.4s;
  transform-origin: bottom;
}

.list-enter {
  opacity: 0;
  transform: rotateX(90deg);
}

.list-leave-to {
  opacity: 0;
  transform: rotateX(90deg);
}
</style>

<style lang="less" scoped>
.middle-bottom {
  padding: 8px 30px 0;
  .mhead {
    margin-top: -60px;
    padding: 13px 24px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .item {
      font-size: 14px;
      color: #a5d4ff;
      opacity: 0.85;
      span {
        font-size: 14px;
        color: #ffffff;
      }
      & + .item {
        margin-left: 20px;
      }
    }
  }
  .table {
    margin: 8px 0px 0;
    .thead {
      display: flex;
      align-items: center;
      background: rgba(68, 96, 218, 0.2);
    }
    .tbody {
      height: 200px;
      overflow: auto;
      &.high {
        height: 452px;
      }
      .item {
        width: 100%;
        height: 46px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(68, 96, 218, 0.2);
        &:nth-of-type(even) {
          background: #002972;
        }
        .i-item {
          font-size: 16px;
          font-weight: normal;
          padding: 0px 0;
          color: #82a9ef;
          &.name {
            padding: 4px 12px;
          }
        }
      }
    }
    .i-item {
      font-size: 16px;
      font-weight: 500;
      color: #00fbff;
      padding: 4px 0;
      &.name {
        width: 50%;
        padding: 4px 12px;
        overflow: hidden; /* 超出部分隐藏 */
        white-space: nowrap; /* 文本不换行 */
        text-overflow: ellipsis; /* 省略的文本用省略号表示 */
      }
      &.percent {
        text-align: center;
        width: 25%;
      }
      &.kcal {
        text-align: center;
        width: 25%;
      }
    }
  }
}
</style>
